import React, { memo } from 'react';
import { XCircle } from 'lucide-react';
import { FadeIn } from './FadeIn';
export function PainPoints() {
  const points = ['Cortás mal y perdés material', 'Entregás y después vienen los reclamos', 'Presupuestás sin saber tu ganancia real', 'Trabajás todo el día sin control del taller'];
  return <section className="py-12 relative overflow-hidden" data-id="element-197">
      <div className="container mx-auto px-4 max-w-4xl relative z-10" data-id="element-198">
        <FadeIn data-id="element-199">
          <h2 className="text-3xl md:text-5xl font-bold text-center mb-6" data-id="element-200">
            ¿Cuánta plata más vas a perder{' '}
            <span className="text-red-500" data-id="element-201">trabajando de memoria?</span>
          </h2>
        </FadeIn>

        <FadeIn delay={0.1} data-id="element-202">
          <p className="text-lg md:text-xl text-gray-300 text-center mb-8 leading-relaxed" data-id="element-203">
            Sabés trabajar. El problema no es tu experiencia.
            <br data-id="element-204" />
            <br data-id="element-205" />
            El problema es seguir calculando de cabeza, cortando a ojo,
            instalando con dudas y presupuestando sin saber si realmente ganás.
            <br data-id="element-206" />
            <br data-id="element-207" />
            <strong className="text-white" data-id="element-208">
              No te falta oficio. Te falta sistema.
            </strong>
          </p>
        </FadeIn>

        <div className="bg-surface p-8 md:p-10 rounded-3xl border border-red-500/20 shadow-[0_0_30px_rgba(239,68,68,0.05)]" data-id="element-209">
          <ul className="space-y-6" data-id="element-210">
            {points.map((point, index) => <FadeIn key={index} delay={0.2 + index * 0.1} data-id="element-211">
                <li className="flex items-start gap-4" data-id="element-212">
                  <XCircle className="w-6 h-6 text-red-500 shrink-0 mt-0.5" data-id="element-213" />
                  <span className="text-lg text-gray-300" data-id="element-214">{point}</span>
                </li>
              </FadeIn>)}
          </ul>
        </div>

        <FadeIn delay={0.8} data-id="element-215">
          <div className="mt-8 text-center" data-id="element-216">
            <p className="text-2xl md:text-3xl font-heading text-gold" data-id="element-217">
              Tu taller no necesita más esfuerzo. Necesita un sistema.
            </p>
          </div>
        </FadeIn>
      </div>
    </section>;
}